import type { MesureResponseModel } from '@/domain/model/measures'

export type GetCurrentQuestionByIdProps = {
  data?: MesureResponseModel
  questionId?: string | null
}
export const getCurrentQuestionById = ({
  data,
  questionId,
}: GetCurrentQuestionByIdProps) => {
  if (!data || !questionId) {
    return undefined
  }

  const questions = data?.questions
  return (
    questions?.find((question) => question.id === Number(questionId)) ||
    undefined
  )
}
